import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFaqStore } from 'src/store/personalization/faq/faq.store';

export const useFaq = () => {
  const navigate = useNavigate();

  const { getFaqList, faqList, isLoadingFaqList } = useFaqStore();

  useEffect(() => {
    getFaqList();
  }, []);

  const TABLEHEADER = [
    { id: 'question', label: 'Pergunta' },
    { id: 'status', label: 'Status', type: 'label' },
  ];

  return {
    navigate,
    TABLEHEADER,
    isLoadingFaqList,
    faqList,
  };
};
